import { branding } from "../config/branding";
import { Workflow } from "../config/workflowConfig";
import { BotAvatar } from "./Icons";

interface LoadingIndicatorProps {
  workflow?: Workflow;
}

export function LoadingIndicator({ workflow = "chat" }: LoadingIndicatorProps) {
  const statusText =
    workflow === "ask_agent"
      ? "Searching…"
      : "Searching KB and generating response…";
  return (
    <div className="flex items-start gap-3">
      <BotAvatar />
      <div className="rounded-2xl rounded-tl-sm border border-gray-200 bg-white px-4 py-3 shadow-sm">
        <p className="text-xs font-medium text-brand-navy">{branding.assistantName}</p>
        <div className="mt-2 flex items-center gap-1.5">
          <span className="h-2 w-2 animate-bounce rounded-full bg-brand-accent [animation-delay:-0.3s]" />
          <span className="h-2 w-2 animate-bounce rounded-full bg-brand-accent [animation-delay:-0.15s]" />
          <span className="h-2 w-2 animate-bounce rounded-full bg-brand-accent" />
        </div>
        <p className="mt-2 text-xs text-gray-500">{statusText}</p>
      </div>
    </div>
  );
}
